import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import { markdown } from '../../utils/markdown';
import { useNamingConventions } from '../../utils/naming-conventions';
import Tooltip from '../../utils/tooltip';

interface InformationTooltipProps {
    information: string;
    className?: string;
}

function InformationTooltip({
    information: rawInformation,
    className = '',
}: InformationTooltipProps) {
    const information = useNamingConventions(rawInformation);

    const content = useMemo(() => markdown(information), [information]);

    return (
        <Tooltip dangerousInput={content}>
            <span className={className}>
                <FontAwesomeIcon icon={faCircleInfo} />
            </span>
        </Tooltip>
    );
}

export default InformationTooltip;
